(function () {
  var root = document.getElementById('child-index-root');
  if (!root) return;
  var groups = Array.prototype.slice.call(root.querySelectorAll('.child-index-letter-group'));
  var azLinks = Array.prototype.slice.call(root.querySelectorAll('.child-index-az-link'));
  var searchInput = document.getElementById('child-index-search-input');
  var noResults = document.getElementById('child-index-no-results');
  var availableLetters = groups.map(function (g) { return g.getAttribute('data-letter-group'); });
  azLinks.forEach(function (link) {
    var letter = link.getAttribute('data-letter');
    if (availableLetters.indexOf(letter) === -1) { link.classList.add('is-disabled'); }
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('letter-' + letter);
      if (!target) return;
      target.classList.remove('is-collapsed');
      target.querySelector('.child-index-letter-header').setAttribute('aria-expanded', 'true');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      azLinks.forEach(function (l) { l.classList.remove('is-active'); });
      link.classList.add('is-active');
    });
  });
  groups.forEach(function (group) {
    var header = group.querySelector('.child-index-letter-header');
    header.addEventListener('click', function () {
      var collapsed = group.classList.toggle('is-collapsed');
      header.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  });
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim().toLowerCase();
      var anyVisible = false;
      groups.forEach(function (group) {
        var items = Array.prototype.slice.call(group.querySelectorAll('.child-index-item'));
        var groupHasMatch = false;
        items.forEach(function (item) {
          var name = (item.getAttribute('data-child-name') || '').toLowerCase();
          var matches = query === '' || name.indexOf(query) !== -1;
          item.classList.toggle('is-hidden', !matches);
          if (matches) groupHasMatch = true;
        });
        group.style.display = groupHasMatch ? '' : 'none';
        if (groupHasMatch && query !== '') {
          group.classList.remove('is-collapsed');
          group.querySelector('.child-index-letter-header').setAttribute('aria-expanded', 'true');
        }
        if (groupHasMatch) anyVisible = true;
      });
      if (noResults) noResults.hidden = anyVisible;
    });
  }
})();
